import { __decorate } from "tslib";
import { AutoEncoder, DateDecoder, EnumDecoder, field, StringDecoder } from '@common/encoding';
import { v4 as uuidv4 } from 'uuid';
import { GroupType } from '../GroupType.js';
import { TranslatedString } from '../TranslatedString.js';
/**
 * Invitation to register for a group. If an invitation exists the member can always register even if he does not meet the requirements of the group.
 * Used for allowing members who are on a waiting list to register for a group.
 */
export class RegistrationInvitationRequest extends AutoEncoder {
    id;
    groupId;
    memberId;
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], RegistrationInvitationRequest.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], RegistrationInvitationRequest.prototype, "groupId", void 0);
__decorate([
    field({ decoder: StringDecoder })
], RegistrationInvitationRequest.prototype, "memberId", void 0);
export class InvitationGroupData extends AutoEncoder {
    id;
    name;
    type;
    periodId;
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], InvitationGroupData.prototype, "id", void 0);
__decorate([
    field(TranslatedString.field({}))
], InvitationGroupData.prototype, "name", void 0);
__decorate([
    field({ decoder: new EnumDecoder(GroupType) })
], InvitationGroupData.prototype, "type", void 0);
__decorate([
    field({ decoder: StringDecoder })
], InvitationGroupData.prototype, "periodId", void 0);
export class InvitationMemberData extends AutoEncoder {
    id;
    firstName = '';
    lastName = '';
    // in case there are members with the same name
    birthDay;
    get name() {
        if (!this.firstName) {
            return this.lastName;
        }
        if (!this.lastName) {
            return this.firstName;
        }
        return this.firstName + ' ' + this.lastName;
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], InvitationMemberData.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], InvitationMemberData.prototype, "firstName", void 0);
__decorate([
    field({ decoder: StringDecoder })
], InvitationMemberData.prototype, "lastName", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], InvitationMemberData.prototype, "birthDay", void 0);
/**
 * Invitation to register for a group. If an invitation exists the member can always register even if he does not meet the requirements of the group.
 * Used for allowing members who are on a waiting list to register for a group.
 */
export class RegistrationInvitation extends AutoEncoder {
    id;
    group;
    member;
    organizationId;
    createdAt = new Date();
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], RegistrationInvitation.prototype, "id", void 0);
__decorate([
    field({ decoder: InvitationGroupData })
], RegistrationInvitation.prototype, "group", void 0);
__decorate([
    field({ decoder: InvitationMemberData })
], RegistrationInvitation.prototype, "member", void 0);
__decorate([
    field({ decoder: StringDecoder })
], RegistrationInvitation.prototype, "organizationId", void 0);
__decorate([
    field({ decoder: DateDecoder })
], RegistrationInvitation.prototype, "createdAt", void 0);
/**
 * Invitation to register for a group. If an invitation exists the member can always register even if he does not meet the requirements of the group.
 * Used for allowing members who are on a waiting list to register for a group.
 */
export class MemberRegistrationInvitation extends AutoEncoder {
    id;
    group;
    organizationId;
    createdAt = new Date();
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], MemberRegistrationInvitation.prototype, "id", void 0);
__decorate([
    field({ decoder: InvitationGroupData })
], MemberRegistrationInvitation.prototype, "group", void 0);
__decorate([
    field({ decoder: StringDecoder })
], MemberRegistrationInvitation.prototype, "organizationId", void 0);
__decorate([
    field({ decoder: DateDecoder })
], MemberRegistrationInvitation.prototype, "createdAt", void 0);
//# sourceMappingURL=RegistrationInvitation.js.map